import { Layout } from '../../components';
import ParticipantTable from '../../components/ParticipantsTable';

const Home = () => (
  <Layout>
    <ParticipantTable />
  </Layout>
);

export default Home;
